import React, { CSSProperties } from "react";

interface IProps {
    style?: CSSProperties;
}

export const TotumLogo: React.FC<IProps> = ({ style }: IProps) => {
    return (
        <svg style={style} xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 100 17">
            <g clipPath="url(#a)">
                <path d="M75.294.309v9.218c0 4.576-2.89 7.472-7.302 7.472-4.433 0-7.281-2.896-7.281-7.472V.31h4.09v8.975c0 2.188.942 3.647 3.19 3.647 2.25 0 3.234-1.436 3.234-3.647V.309h4.07ZM99 .309v16.38h-4.09V9.064l-3.234 7.604h-2.698l-3.255-7.604v7.627h-4.069V.309h4.112l4.54 10.301L94.867.31H99ZM27.454 0c-4.54 0-8.416 3.78-8.416 8.511 0 4.73 3.876 8.511 8.416 8.511 4.561 0 8.416-3.758 8.416-8.51 0-4.754-3.855-8.512-8.416-8.512Zm0 12.932c-2.377 0-4.283-1.967-4.283-4.421s1.906-4.421 4.283-4.421c2.398 0 4.283 1.945 4.283 4.421s-1.885 4.421-4.283 4.421Z" />
                <path d="M27.454 0c-4.54 0-8.416 3.78-8.416 8.511 0 4.73 3.876 8.511 8.416 8.511 4.561 0 8.416-3.758 8.416-8.51 0-4.754-3.855-8.512-8.416-8.512Zm0 12.932c-2.377 0-4.283-1.967-4.283-4.421s1.906-4.421 4.283-4.421c2.398 0 4.283 1.945 4.283 4.421s-1.885 4.421-4.283 4.421ZM40.86.309a19.959 19.959 0 0 1 1.092 4.111h3.876v12.27h4.09V4.42h4.925V.31H40.86ZM0 .309A19.96 19.96 0 0 1 1.092 4.42h3.876v12.27h4.09V4.42h4.926V.31H0Z" />
            </g>
            <defs>
                <clipPath id="a">
                    <path d="M0 0h99v17H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
